import { useEffect } from "react";
import { useReveal } from "@/hooks/useReveal";
import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import WhatIsCoaching from "@/components/site/WhatIsCoaching";
import Obstacles from "@/components/site/Obstacles";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useReveal();

  useEffect(() => {
    document.title = "Noa Grant Coaching · Parent & ADHD Coach";
  }, []);

  return (
    <div data-testid="landing-page" className="bg-paper min-h-screen">
      <Navigation />
      <main>
        <Hero />
        <WhatIsCoaching />
        <Obstacles />
        <Services />
        <About />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
